import { styled, secondaryFontFamily } from '@openeducation/oe-rn-themes';
import React, { FC, memo, ReactNode } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { OEText } from '../../atoms/oe-text/oe-text';
import { flex, mb } from '../../style-utils';

export interface PageSectionHeaderProps {
  title?: string;
  subtitle?: string;
  headerRight?: ReactNode;
  style?: StyleProp<ViewStyle>;
}

const PageSectionHeader: FC<PageSectionHeaderProps> = ({
  title,
  subtitle,
  headerRight,
  style,
}) => {
  return (
    <View style={[flex('flex-row'), mb(title ? 30 : 0), style]}>
      <View style={[flex('flex-1')]}>
        {!!title && <Title>{title}</Title>}
        {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
      </View>
      {headerRight}
    </View>
  );
};

const Title = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.text,
  fontSize: 20,
  fontType: 'semiBold',
  fontFamily: secondaryFontFamily,
}))``;

const Subtitle = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.dark3,
  fontSize: 16,
  fontFamily: secondaryFontFamily,
}))``;

export default memo(PageSectionHeader);
